<template>
  <div id="otAbout">
    <div id="otTopInput">
      <el-input
        placeholder="请输入组织名称查询"
        v-model="filterText"
        class="input-with-select"
        size="small"
        clearable>
        <el-button slot="append" icon="el-icon-search" @click="treeFilter"></el-button>
      </el-input>
    </div>
    <div id="otTreeDiv">
      <el-tree
        class="filter-tree_1"
        :load="loadNode"
        lazy
        :props="defaultProps"
        node-key="id"
        highlight-current
        :expand-on-click-node="false"
        @node-click="treeNodeClick"
        :filter-node-method="filterNode"
        :default-expanded-keys="defaultExpandedKeys"
        ref="tree">
        <div class="custom-tree-node" style="width:100%;" slot-scope="{ node, data }">
          <div style="width:100%;background:#ddd;border-radius:4px;text-align:center;" v-if="data.id == 'loadMore'" @click="loadMore($event,data)">加载更多</div>
          <div v-else style="font-size: 14px;color:#606266;">{{ node.label }}</div>
        </div>
      </el-tree>
    </div>
  </div>
</template>

<script>
  import {getAdmOrgTree} from '../api/admOrg'
  import main from "../views/defaultImg";
  export default {
    data () {
      return {
        loginInfo:JSON.parse(sessionStorage.getItem("Admin-Data")||'{}'),
        page :1,
        rows:15,
        curNode:null,
        curResolve:null,
        filterText: '',
        enumData: [],
        defaultProps: {
          children: 'children',
          label: 'label',
          isLeaf: 'leaf'
        },
        parentId: '-1',
        nodeId: '',
        chooseTreeNode: {},
        defaultExpandedKeys: []
      }
    },
    props: {
      parentMsg: Object,
    },
    watch: {
      parentMsg (newVal, oldVal) {
        this.getTemplateTree('refresh')
      }
    },
    mounted: function () {
      // this.getTemplateTree('new')
    },
    methods: {
      loadMore(ev,data){
        this.curNode = data.node
        this.curResolve = data.resolve
        this.page++
        this.getTemplateTree(this.curNode,this.curResolve,'loadMore')
        ev.stopPropagation()//阻止事件往下传递
        ev.preventDefault();
      },
      loadNode(node, resolve) {
        if(this.curNode&&this.curNode.data&&node.data&&(this.curNode.data.id != node.data.id)){
          this.page = 1
        }
        this.curNode = node
        this.curResolve = resolve
        this.getTemplateTree(node,resolve)
      },
      treeFilter () {
        // this.page = 1
        // this.getTemplateTree(this.curNode,this.curResolve,'query')
        this.$refs.tree.filter(this.filterText)
      },
      getTemplateTree (node,resolve,type) {
        if(type == 'loadMore'){
          node.childNodes = node.childNodes.filter(it=>it.id!='loadMore')
          this.page = Math.floor(node.childNodes.length / this.rows) + 1
        }
        let data = {async:1}
        if (node.level==0){
          if(this.$route.query.pid){
            data.orgId = this.$route.query.pid//'1045876675263762432'
            if(this.$route.query.pname){
              data.name = this.$route.query.pname
            }
          }else{
            delete data.orgId
          }
        }else{
          data.orgId = node.data.id
          data.page = this.page
          let isIc = !!this.$funcUtil.roleCheck().find(it=>it.type == 'ic')//是否保险机构账号
          if(isIc){//是保险公司
            if(node.data.id == '1045876734075539456'){//点中保险公司节点，查询当前账号的保险公司
              data.name = this.loginInfo.orgName
              data.orgId = this.loginInfo.orgs[0].parentId
            }else{
            }
            if(node.data.id == '1045876675263762432'){//点中企业管理节点，查询当前保险公司所属的企业
              data.linkOrgId = this.loginInfo.orgId
            }
          }
          // data.rows = this.rows
        }
        if(node.level==2){
          data.rows = this.rows
        }
        if(type == 'query'&&this.filterText){
          data.name = this.filterText
        }
        getAdmOrgTree(this.$qs.stringify(data)).then(response => {
          if (response.length <= 0) {
            this.enumData = []
            // this.$emit('treeInfo', { 'listenParentId': '-1', 'listenParentName': '暂无' })
          } else {
            let temp = Array.isArray(response)?response:response.rows
            temp.forEach(it=>{
              it.leaf = it.state == 'open'
            })
            if(node.level==1){
              let isIc = !!this.$funcUtil.roleCheck().find(it=>it.type == 'ic')//是否保险机构账号
              if(isIc){
                temp = temp.filter(it=>it.id != '1045876813195284480')//保险机构过虑掉服务机构
              }
            }
            // 展开至第一级
            if (node.level==0){
              if(this.$route.query.pid&&this.$route.query.pid == '1045876675263762432'){//企业
                temp = [{
                  id:this.$route.query.pid,
                  label:'企业管理',
                  text:'企业管理',
                  attributes:{
                    orgTypeCode:'qy',
                  },
                  children:temp
                }]
              }else if(this.$route.query.pid&&this.$route.query.pid == '1045876734075539456'){//保险公司
                temp = [{
                  id:this.$route.query.pid,
                  label:'保险公司管理',
                  text:'保险公司管理',
                  attributes:{
                    orgTypeCode:'bx',
                  },
                  children:temp
                }]
              }
              this.defaultExpandedKeys = [temp[0].id]
              this.$nextTick(() => {
                this.$refs.tree.setCurrentKey(temp[0].id)
              })
              this.$emit('treeInfo', { 'listenParentId': temp[0].id, 'listenParentName': temp[0].label })
            }
            if (node.level==2){
              let x = response.total % this.rows
              let nums = Math.floor(response.total / this.rows)
              nums = x>0?nums + 1:nums
              if(this.page <= nums - 1&&response.total>(node.childNodes.length>0?node.childNodes.length:temp.length)){
                temp.push({
                  id:'loadMore',
                  label:'加载更多',
                  parentId:node.data.id,
                  leaf: true,
                  node:node,
                  resolve:resolve
                })
              }
            }
            if(type == 'loadMore'){
              node.childNodes.pop()
              let oldChild = node.childNodes.map(item => item.data)
              this.enumData = oldChild.concat(temp)
            }else{
              this.enumData = temp
            }
          }
          resolve(this.enumData)
        }).catch(error => {
          console.log('error:' + error.toString())
        })
      },
      treeNodeClick (node) {
        this.chooseTreeNode = node
        this.$emit('treeInfo', { 'listenParentId': node.id, 'listenParentName': node.label,type:node.attributes.orgTypeCode })
      },
      filterNode (value, data) {
        if (!value) return true
        return data.label.indexOf(value) !== -1
      },
      selectOrg(id, name) {
        this.filterText = name
        this.$refs.tree.filter(this.filterText)
        this.$nextTick(()=> {
          this.$refs.tree.setCurrentKey(id)
        })
      }
    },
  }
</script>

<style scoped lang="less">
  #otAbout {
    height: 100%;
  }

  #otTreeDiv {
    width: 100%;
    height: 95%;
    height: calc(100% - 32px - 10px);
    margin-top: 10px;
    overflow: auto;
  }
</style>
<style lang="less">
.filter-tree_1{
  width: 100%;
  .el-tree-node .el-tree-node__children{
    overflow: initial;
  }
  }
</style>



// WEBPACK FOOTER //
// src/components/OrgTree.vue